import { useEffect, useRef } from 'react';

export default function GenderPulse() {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let rafId: number;
    const animate = (t: number) => {
      const scale = 1 + 0.3 * Math.sin(t / 300);
      const opacity = 0.6 + 0.4 * Math.sin(t / 300);
      el.style.transform = `scale(${scale})`;
      el.style.opacity = String(opacity);
      rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <span
      ref={ref}
      className="inline-block w-3.5 h-3.5 rounded-full bg-white mr-1.5 align-middle"
      aria-hidden="true"
    />
  );
}
